"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DesignerContent;

var React = _interopRequireWildcard(require("react"));

var _reactJss = require("react-jss");

var _BackFields = _interopRequireDefault(require("../fields/BackFields"));

var _Theme = require("../../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _reactJss.createUseStyles)({
  root: {
    backgroundColor: '#f3f3f3',
    filter: 'drop-shadow(5px 11px 15px rgba(0, 0, 0, 0.2))',
    padding: function padding(_ref) {
      var theme = _ref.theme;
      return 14 * theme.scale;
    },
    width: function width(_ref2) {
      var theme = _ref2.theme;
      return 320 * theme.scale;
    },
    height: function height(_ref3) {
      var theme = _ref3.theme;
      return 450 * theme.scale;
    }
  },
  container: {
    flexDirection: 'column',
    alignItems: 'center',
    display: 'flex',
    height: function height(_ref4) {
      var theme = _ref4.theme;
      return theme.scale * 80;
    },
    justifyContent: 'center',
    width: '100%'
  }
});

function DesignerContent() {
  var theme = (0, _Theme.useTheme)();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }), /*#__PURE__*/React.createElement(_BackFields.default, null));
}
//# sourceMappingURL=DesignerContent.js.map